import { FuelSurchargeType } from '../components/FuelSurchargeFields';
import { RateType, RateTypeOption } from '../components/RateGrid';
import { PlsLoadSize } from './types';

export enum AvailableTabs {
  customer = 'customer',
  billTo = 'billTo',
  specifications = 'specifications',
  items = 'items',
  route = 'route',
  rates = 'rates',
  operationalFields = 'operationalFields',
  optional = 'optional',
}

export const ALL_PLS_TABS = Object.values(AvailableTabs);

export const FORM_RESET_OPTIONS = {
  keepDefaultValues: false,
  keepTouched: false,
  keepDirtyValues: false,
  keepDirty: false,
};

export const FIELD_PREFIX_MAP: Record<string, string> = {
  customer: 'Customer',
  billTo: 'Bill To',
  stops: 'Route',
  pickup: 'Pickup',
  consignee: 'Consignee',
  specifications: 'Specs',
  commodities: 'Items',
  plsOperationalFields: 'Customer Reference Fields',
  plsLoadReferenceFields: 'Load Reference Fields',
  plsPickupReferenceFields: 'Pickup Reference Fields',
  plsConsigneeReferenceFields: 'Consignee Reference Fields',
};

export const PLS_SECTION_LABELS = {
  customer: 'Customer',
  location: 'Location',
  billTo: 'Bill To',
  loadSize: 'Load Size',
  equipment: 'Equipment',
  items: 'Items',
  operationalFields: 'Customer Reference Fields',
  serviceType: 'Service Type',
  accessorials: 'Accessorials / Tarps',
} as const;

// AI-filled hint tooltip when the suggested equipment is only the service's default.
export const PLS_UNCONFIRMED_EQUIPMENT_HINT =
  "Not in the email or this customer's history. Check the equipment.";

export const PLS_FIELD_LIMITS = {
  operationalFieldValue: 255,
  referenceFieldValue: 255,
  referenceNumber: 50,
  commodityName: 200,
} as const;

export const PLS_BILL_TO_SEARCH_API_ENABLED = true;

// Users see Drumkit's "TL"; the value stays PLS's wire value "FTL" (see PlsLoadSize).
export const PLS_LOAD_SIZE_OPTIONS = [
  { value: PlsLoadSize.FTL, label: 'TL' },
  { value: PlsLoadSize.LTL, label: 'LTL' },
];

export const PLS_DIMENSION_UNIT_OPTIONS = [
  { value: 'in', label: 'Inches' },
  { value: 'ft', label: 'Feet' },
  { value: 'cm', label: 'Centimeters' },
] as const;

export const PLS_APPOINTMENT_TYPE = {
  FCFS: 'FCFS',
  ByAppointment: 'By appointment',
} as const;

export const PLS_APPOINTMENT_TYPE_OPTIONS = [
  { value: PLS_APPOINTMENT_TYPE.FCFS, label: 'FCFS' },
  { value: PLS_APPOINTMENT_TYPE.ByAppointment, label: 'By appointment' },
] as const;

export const PLS_STOP_ACTION_OPTIONS = [
  { value: 'pickup', label: 'Pickup' },
  { value: 'dropoff', label: 'Dropoff' },
] as const;

// PLS line haul types (FLAT_RATE, PER_MILE, CWT); the backend maps these to its codes on create.
// A PLS line is a type and one value: the line haul itself for a flat rate, else a rate PLS
// multiplies by the trip's miles or the items' hundredweight. PLS has no separate rating units.
export const PLS_RATE_TYPE_OPTIONS: RateTypeOption[] = [
  {
    value: RateType.Flat,
    label: 'Flat Rate',
    rateLabel: 'Line Haul',
    rateIsLineHaul: true,
  },
  {
    value: RateType.Distance,
    label: 'Per Mile',
    rateLabel: 'Rate per Mile',
    unitsLabel: 'Miles',
  },
  {
    value: RateType.CWT,
    label: 'CWT',
    rateLabel: 'Rate per CWT',
    unitsLabel: 'Hundredweight',
  },
];

// PLS fuel lines: PCT_OF_LH, PER_MILE and FLAT_RATE, in the order a tender usually states them.
export const PLS_FUEL_SURCHARGE_TYPE_OPTIONS = [
  { value: FuelSurchargeType.Percent, label: 'Fuel % of Line Haul' },
  { value: FuelSurchargeType.PerMile, label: 'Fuel per Mile' },
  { value: FuelSurchargeType.Flat, label: 'Fuel Flat' },
];
